import { useCallback, useState } from 'react';
import { PushButton } from './PushButton';

export const PushButtonContainer = (props) => {

    let { numPlate, idSubPlate, idSlot, additional, indexAdditional, type, itemType, assembly, plateModel, buttonsContent } = props
    let { addPushButtonToSlot, addPushButtonToFirstSlot, addPushButtonToAllPlate } = props

    const [hovered, setHovered] = useState({ idButton: null, rows: 1 })

    const onHoverChange = useCallback(({ active, idButton, rows }) => {
        if (plateModel !== 'ultra') return
        setHovered(prev => {
            if (!active) {
                if (prev.idButton !== idButton) return prev
                return { idButton: null, rows: 1 }
            }

            const nextRows = rows || 1
            if (prev.idButton === idButton && prev.rows === nextRows) return prev
            return { idButton, rows: nextRows }
        })
    }, [plateModel])

    const renderHighlightOverlay = () => {
        if (plateModel !== 'ultra') return null
        if (!hovered.idButton) return null

        const isSingleButtonSlot = Array.isArray(buttonsContent) && buttonsContent.length === 1

        const baseHeight = assembly === "embedded" ? 38 : 45
        const gap = 1
        const rows = Math.max(1, Math.min(3, parseInt(hovered.rows, 10) || 1))
        const height = `${(rows * baseHeight) + ((rows - 1) * gap)}px`

        const overlayStyle = {
            position: 'absolute',
            left: 0,
            right: 0,
            height,
            outline: '2px solid #009440',
            backgroundColor: '#e9e9e94f',
            pointerEvents: 'none',
            zIndex: 10
        }

        // En módulos con un solo hueco (p.ej. UT2020), el pulsador se renderiza abajo.
        if (isSingleButtonSlot) {
            overlayStyle.bottom = 0
        } else {
            if (hovered.idButton === 1) overlayStyle.top = 0
            if (hovered.idButton === 2) overlayStyle.top = assembly === "surface" ? 46 : 39
            if (hovered.idButton === 3) overlayStyle.top = assembly === "surface" ? 91 : 77
            if (hovered.idButton === 4) overlayStyle.bottom = 0
        }

        return <div style={overlayStyle} />
    }

    let renderedPushButtons = []
    for (let i = 0; i < buttonsContent.length; i++) {
        const buttonContent = buttonsContent[i];
        if (buttonContent && buttonContent.occupied) continue

        const buttonIndex = buttonContent && buttonContent.idButton ? buttonContent.idButton : i + 1

        let position = 'left-0 '
        if (buttonsContent.length === 1){
            position += 'bottom-0'
        }
        else {
            if (buttonIndex === 1){
                position += 'top-0'
            }
            if (buttonIndex === 2){
                position += assembly === "surface" ? 'top-46' : 'top-39'
            }
            if (buttonIndex === 3){
                position += assembly === "surface" ? 'top-91' : 'top-77'
            }
            if (buttonIndex === 4 ){
                position += 'bottom-0'
            }
        }

        renderedPushButtons.push(
            <PushButton
                key = { buttonIndex }
                src = { buttonContent.src }
                deepLink = { buttonContent.deepLink }
                articleCode = {buttonContent.articleCode}
                eanCode = {buttonContent.eanCode}
                description = { buttonContent.description }
                toolTip = { buttonContent.toolTip }
                idCategory = { buttonContent.idCategory }
                category = { buttonContent.category }
                pvp = { buttonContent.pvp }
                numCalls = { buttonContent.numCalls }
                numRows = { buttonContent.numRows }
                idButton = { buttonContent.idButton }
                buttonsContent = { buttonsContent }
                plateInfo = { props.plateInfo }
                location = { itemType }
                plateModel = { plateModel } 
                assembly = { assembly }
                numPlate = { numPlate }
                idSubPlate = { idSubPlate }
                idSlot = { idSlot }
                type = { type }
                additional = { additional }
                indexAdditional = { indexAdditional }
                addPushButtonToSlot = { addPushButtonToSlot }
                addPushButtonToAllPlate = { addPushButtonToAllPlate }
                addPushButtonToFirstSlot = { addPushButtonToFirstSlot }
                position = { position }
                onHoverChange = { onHoverChange }
                t = {props.t}
            />

        )
    }

    return (
        <>
            { renderHighlightOverlay() }
            { renderedPushButtons }
        </>
    )
};
